<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <img
          alt="gmk ogre"
          class="img-fluid"
          src="../../public/jpg/gmk ogre/hero-banner.png"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <img class="img-fluid" src="../../public/jpg/gmk ogre/hero.png" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h2>base kit</h2>
        <img class="img-fluid" src="../../public/jpg/gmk ogre/1-base-kit.png" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <img
          class="img-fluid"
          src="../../public/jpg/gmk ogre/alice-beige.png"
        />
      </div>
      <div class="col">
        <h2>ogricons</h2>
        <img class="img-fluid" src="../../public/jpg/gmk ogre/4-ogricons.png" />
      </div>
    </div>
    <div class="row">
      <div class="color-square-holder col-md-2">
        <h4>RAL 1000</h4>
        <div class="color-square-border">
          <h5>green beige</h5>
          <div class="green-beige color-square"></div>
        </div>
      </div>
      <div class="color-square-holder col-md-2">
        <h4>RAL 6020</h4>
        <div class="color-square-border">
          <h5>chrome green</h5>
          <div class="chrome-green color-square"></div>
        </div>
      </div>
      <div class="color-square-holder col-md-2">
        <h4>RAL 6022</h4>
        <div class="color-square-border">
          <h5>
            olive
            <br />drab
          </h5>
          <div class="olive-drab color-square"></div>
        </div>
      </div>
      <div class="color-square-holder col-md-2">
        <h4>gmk</h4>
        <div class="color-square-border">
          <h5>
            stock
            <br />ae
          </h5>
          <div class="gmk-ae-green color-square"></div>
        </div>
      </div>
      <div class="color-square-holder col-md-2">
        <h4>gmk</h4>
        <div class="color-square-border">
          <h5>
            stock
            <br />ro2
          </h5>
          <div class="gmk-ro2-red color-square"></div>
        </div>
      </div>
      <div class="color-square-holder col-md-2">
        <h4>gmk</h4>
        <div class="color-square-border">
          <h5>
            stock
            <br />n9
          </h5>
          <div class="gmk-n9-grey color-square"></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <img class="img-fluid" src="../../public/jpg/gmk ogre/ral1000.png" />
      </div>
      <div class="col-md-4">
        <img class="img-fluid" src="../../public/jpg/gmk ogre/ral6020.png" />
      </div>
      <div class="col-md-4">
        <img class="img-fluid" src="../../public/jpg/gmk ogre/ral6022.png" />
      </div>
    </div>
    <div class="row">
      <div class="col-md6">
        [url=https://geekhack.org/index.php?topic=.msg8#msg8][img width=475
        height=100]/jpg/gmk ogre/hero-banner.png[/img][/url]
        <img
          class="img-fluid"
          src="../../public/jpg/gmk ogre/hero-banner.png"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h2>numpad</h2>
        <img class="img-fluid" src="../../public/jpg/gmk ogre/2 numpad.png" />
      </div>
      <div class="col">
        <h2>color</h2>
        <img class="img-fluid" src="../../public/jpg/gmk ogre/3-color.png" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h2>40s</h2>
        <img class="img-fluid" src="../../public/jpg/gmk ogre/5-40.png" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h2>space</h2>
        <img class="img-fluid" src="../../public/jpg/gmk ogre/6-space.png" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <img class="img-fluid" src="../../public/jpg/gmk ogre/alice.png" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <img class="img-fluid" src="../../public/jpg/gmk ogre/all-green.png" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <img class="img-fluid" src="../../public/jpg/gmk ogre/beige-2.png" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <img
          class="img-fluid"
          src="../../public/jpg/gmk ogre/all-green-black.png"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <img class="img-fluid" src="../../public/jpg/gmk ogre/numpad.png" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <img class="img-fluid" src="../../public/jpg/gmk ogre/beige-3.png" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <img class="img-fluid" src="../../public/jpg/gmk ogre/beige-4.png" />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <img class="img-fluid" src="../../public/jpg/gmk ogre/60.png" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-4"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {}
};
</script>
<style lang="scss" scoped>
.green-beige {
  background-color: rgb(190, 189, 127);
}

.chrome-green {
  background-color: rgb(46, 58, 35);
}

.olive-drab {
  background: rgb(37, 34, 27);
}

.gmk-ae-green {
  background: #689b34;
}

.gmk-ro2-red {
  background: #ff2811;
}

.gmk-n9-grey {
  background: #393b3b;
}

.color-square {
  width: 100%;
  height: 150px;
}

.color-square-holder {
  border: 5px solid white;
  background-color: white;
  h4 {
    font-size: 1rem;
    color: black;
    font-weight: bold;
  }
  .color-square-border {
    border: 5px solid black;
    background: black;
    h5 {
      font-size: 2rem;
      color: white;
    }
  }
}
</style>
